module.exports = {"Administración de franjas horarias":"Administración de franjas horarias","Listado de franjas horarias":"Listado de franjas horarias","Ver franja horaria":"Ver franja horaria","Editar franja horaria":"Editar franja horaria","Nueva franja horaria":"Nueva franja horaria","Nombre":"Nombre","Desde":"Desde","Hasta":"Hasta","Porcentaje de recargo de salario":"Porcentaje de recargo de salario","lunes a viernes":"lunes a viernes","sábados":"sábados","domingos":"domingos","feriados":"feriados","Porcentaje de horas extras":"Porcentaje de horas extras"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/franjas-horarias/es.json
// module id = 1165
// module chunks = 0